import { render, staticRenderFns } from "./campusDetailCen.vue?vue&type=template&id=278d6090&scoped=true"
import script from "./campusDetailCen.vue?vue&type=script&lang=js"
export * from "./campusDetailCen.vue?vue&type=script&lang=js"
import style1 from "./campusDetailCen.vue?vue&type=style&index=1&id=278d6090&prod&scoped=true&lang=scss"
import style2 from "./campusDetailCen.vue?vue&type=style&index=2&id=278d6090&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278d6090",
  null
  
)

export default component.exports